/*
 * Copyright (c) 2000-2023 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import firebase from 'firebase/compat/app';
import {firebaseConfig} from '@/api/backend/settings/connection-settings';

/**
 * Import Firebase SDK parts that the application needs.
 */
import 'firebase/compat/auth';
import 'firebase/compat/database';

/**
 * The Firebase application.
 */
const app = firebase.initializeApp(firebaseConfig);

/**
 * The Firebase Auth service for the current app.
 */
export const firebaseAuth = app.auth();

/**
 * The Firebase Database service for the current app.
 */
export const firebaseDatabase = app.database();
